<template>
  <div 
    class="fts-automation-node-start automation-node" 
    :class="{ 
      'automation-node--debug': data.debug, 
      'automation-node--debugging': isDebugging,   
    }">
    <div class="node-header node-header--center">
      <div class="node-header__label">
        <font-awesome-icon :icon="['far', 'play-circle']" class="node-header-icon" />
        <div class="node-header-title">Start</div>
      </div>
      <fts-automation-debugpoint v-model="data.debug" class="node-header__debugpoint" />
    </div>
    <div class="node-body">
      <div class="node-body__content">Triggers when user submitting the form</div>
    </div>
  </div>
</template>

<script>
import { automationDesignStore } from "../../store/automationDesignStore";

import FTSAutomationScopedVariables from "./FTSAutomationScopedVariables";
import FTSAutomationDebugpoint from "./FTSAutomationDebugpoint";

export default {
  props: {
    data: Object,
    information: Array,
  },
  data() {
    return {
      editor: null,
      show: -1,
      content: "",
      isDebugging: false,
    };
  },
  components: {
    "fts-automation-scoped-variables": FTSAutomationScopedVariables,
    "fts-automation-debugpoint": FTSAutomationDebugpoint,
  },
  computed: {
    variables() {
      return automationDesignStore.state.variables;
    },
  },
  mounted() {
    let vm = this;

    window.eventBus.$on("refreshAutomationBlocks", () => {
      vm.isDebugging = false;
      if (automationDesignStore.state.debugPayload && automationDesignStore.state.debugPayload.nodeId) {
        let nodeId = automationDesignStore.state.debugPayload.nodeId;
        let diagram = automationDesignStore.state.diagram;
        if (diagram[nodeId].data.id == vm.data.id) {
          vm.isDebugging = true;
        }
      }

      vm.$forceUpdate();
    });
  },
  beforeDestroy() {
    window.eventBus.$off("refreshAutomationBlocks");
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-automation-node-start {
  width: 300px;
  .node-header {
    position: relative;
    .node-header__debugpoint {
      @include absolute-center-y;
      right: 1rem;
    }
  }
  .node-body {
    .node-body__content {
      font-size: .875rem;
      text-align: center;
    }
  }
}
</style>